// Dependencies.
import styled from 'styled-components'
import { useMemo } from 'react'

import { SectionField } from '../../Inputs/SectionField'
import { TextArea } from '../../Inputs/TextArea'
import { EventHookInterface, NookEvent } from '../../../types'
import { H4 } from '../../H4'
import { colors } from '../../../utils'
import { Hyperlink } from '../../Hyperlink'

// Div.
const Div = styled.div`
  .hostImageAndName {
    align-items: center;
    display: flex;
    justify-content: flex-start;
  }

  .hostImage {
    background-color: ${colors.grey};
    background-position: center;
    background-size: cover;
    border-radius: 100%;
    height: 80px;
    margin-right: 15px;
    width: 80px;
  }

  .hostName {
    text-align: left;
    color: ${colors.purple};
  }

  .textArea.readOnly {
    margin-top: 30px;
  }

  .hyperlink {
    text-decoration: none;
  }
`

// Props.
interface Props {
  eventHook: EventHookInterface
}

// Host Bio.
export const HostBio: React.FC<Props> = (props) => {
  // Event.
  const { eventHook } = props
  const { isEditable, value } = eventHook
  const { host, hosted_group } = value as NookEvent
  const header = isEditable ? 'Host bio' : 'Hosted by'
  const subheader = isEditable
    ? 'Add a bio about yourself so your participants can get to know you'
    : ''

  if (isEditable || (!host && !hosted_group)) return null
  // ..
  return (
    <SectionField header={header} subheader={subheader}>
      <Div>
        {hosted_group ? (
          <div className="hostImageAndName">
            {/* Image. */}
            <div
              className="hostImage"
              style={{
                backgroundImage: `url(${
                  hosted_group.image ? hosted_group.image : '/images/avatar.png'
                })`,
              }}
            />
            {/* Name. */}
            <Hyperlink href={`/pages/${hosted_group.url}`} newTab={true}>
              <H4 className="hostName">{hosted_group.name}</H4>
            </Hyperlink>
          </div>
        ) : (
          <div className="hostImageAndName">
            {/* Image. */}
            <div
              className="hostImage"
              style={{
                backgroundImage: `url(${
                  host.image ? host.image : '/images/avatar.png'
                })`,
              }}
            />
            {/* Name. */}
            <H4 className="hostName">{host.name}</H4>
          </div>
        )}
      </Div>
    </SectionField>
  )
}
